document.addEventListener(
  "DOMContentLoaded",
  () => {

    const sections =
      document.querySelectorAll(
        ".testimonial-slider"
      );

    sections.forEach((section) => {

      const track =
        section.querySelector(
          "[data-testimonial-slider]"
        );

      const prev =
        section.querySelector(
          ".testimonial-slider__arrow--prev"
        );

      const next =
        section.querySelector(
          ".testimonial-slider__arrow--next"
        );

      if (!track) return;

      const scrollAmount = 380;

      next?.addEventListener(
        "click",
        () => {

          track.scrollBy({
            left: scrollAmount,
            behavior: "smooth",
          });

        }
      );

      prev?.addEventListener(
        "click",
        () => {

          track.scrollBy({
            left: -scrollAmount,
            behavior: "smooth",
          });

        }
      );

    });

  }
);